import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@digital/ui/assets/css/main.css';
import '../public/main.css';
import '../public/mrn.css';
import {initMsal } from "./config/msalConfig";

(async () => {
  await initMsal();
  ReactDOM.render(<App />, document.getElementById("root"));
})();